function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTulip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "gradient-object",
    id: "Tulip",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 309.2 303.7",
    style: {
      accentColor: "auto",
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      anchorScope: "none",
      animationComposition: "replace",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationRangeEnd: "normal",
      animationRangeStart: "normal",
      animationTimeline: "auto",
      animationTimingFunction: "ease",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: "180.469px",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxDecorationBreak: "slice",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      containIntrinsicBlockSize: "none",
      containIntrinsicHeight: "none",
      containIntrinsicInlineSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicWidth: "none",
      containerName: "none",
      containerType: "normal",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "&quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: 16,
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesisSmallCaps: "auto",
      fontSynthesisStyle: "auto",
      fontSynthesisWeight: "auto",
      fontVariant: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantEmoji: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "180.469px",
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: "183.75px",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      interpolateSize: "numeric-only",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskClip: "border-box",
      maskComposite: "add",
      maskImage: "none",
      maskMode: "match-source",
      maskOrigin: "border-box",
      maskPosition: "0% 0%",
      maskRepeat: "repeat",
      maskSize: "auto",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offsetAnchor: "auto",
      offsetDistance: 0,
      offsetPath: "none",
      offsetPosition: "normal",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: "content-box",
      overflowWrap: "normal",
      overflowX: "hidden",
      overflowY: "hidden",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "91.875px 90.2344px",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionArea: "none",
      positionTryFallbacks: "none",
      positionTryOrder: "normal",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      right: "auto",
      rotate: "none",
      rowGap: "normal",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      scrollTimelineAxis: "block",
      scrollTimelineName: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textEmphasisColor: "rgb(33, 37, 41)",
      textEmphasisPosition: "over",
      textEmphasisStyle: "none",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      textWrapMode: "wrap",
      textWrapStyle: "auto",
      timelineScope: "none",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "91.875px 90.2344px",
      transformStyle: "flat",
      transitionBehavior: "normal",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "middle",
      viewTimelineAxis: "block",
      viewTimelineInset: "auto",
      viewTimelineName: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      whiteSpaceCollapse: "collapse",
      widows: 2,
      width: "183.75px",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    },
    xmlSpace: "preserve",
    width: 183.75,
    height: 180.469,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_18",
    style: {
      accentColor: "auto",
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      anchorScope: "none",
      animationComposition: "replace",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationRangeEnd: "normal",
      animationRangeStart: "normal",
      animationTimeline: "auto",
      animationTimingFunction: "ease",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxDecorationBreak: "slice",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      containIntrinsicBlockSize: "none",
      containIntrinsicHeight: "none",
      containIntrinsicInlineSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicWidth: "none",
      containerName: "none",
      containerType: "normal",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "&quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: 16,
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesisSmallCaps: "auto",
      fontSynthesisStyle: "auto",
      fontSynthesisWeight: "auto",
      fontVariant: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantEmoji: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      interpolateSize: "numeric-only",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskClip: "border-box",
      maskComposite: "add",
      maskImage: "none",
      maskMode: "match-source",
      maskOrigin: "border-box",
      maskPosition: "0% 0%",
      maskRepeat: "repeat",
      maskSize: "auto",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offsetAnchor: "auto",
      offsetDistance: 0,
      offsetPath: "none",
      offsetPosition: "normal",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionArea: "none",
      positionTryFallbacks: "none",
      positionTryOrder: "normal",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      right: "auto",
      rotate: "none",
      rowGap: "normal",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      scrollTimelineAxis: "block",
      scrollTimelineName: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textEmphasisColor: "rgb(33, 37, 41)",
      textEmphasisPosition: "over",
      textEmphasisStyle: "none",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      textWrapMode: "wrap",
      textWrapStyle: "auto",
      timelineScope: "none",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionBehavior: "normal",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimelineAxis: "block",
      viewTimelineInset: "auto",
      viewTimelineName: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      whiteSpaceCollapse: "collapse",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "leaf-1",
    gradientUnits: "userSpaceOnUse",
    x1: 858.1535,
    y1: -215.4497,
    x2: 1011.92,
    y2: -215.4497,
    gradientTransform: "matrix(1 0 0 -1 -858.14 -49.79)",
    style: {
      accentColor: "auto",
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      anchorScope: "none",
      animationComposition: "replace",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationRangeEnd: "normal",
      animationRangeStart: "normal",
      animationTimeline: "auto",
      animationTimingFunction: "ease",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxDecorationBreak: "slice",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      containIntrinsicBlockSize: "none",
      containIntrinsicHeight: "none",
      containIntrinsicInlineSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicWidth: "none",
      containerName: "none",
      containerType: "normal",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "&quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: 16,
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesisSmallCaps: "auto",
      fontSynthesisStyle: "auto",
      fontSynthesisWeight: "auto",
      fontVariant: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantEmoji: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      interpolateSize: "numeric-only",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskClip: "border-box",
      maskComposite: "add",
      maskImage: "none",
      maskMode: "match-source",
      maskOrigin: "border-box",
      maskPosition: "0% 0%",
      maskRepeat: "repeat",
      maskSize: "auto",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offsetAnchor: "auto",
      offsetDistance: 0,
      offsetPath: "none",
      offsetPosition: "normal",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionArea: "none",
      positionTryFallbacks: "none",
      positionTryOrder: "normal",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      right: "auto",
      rotate: "none",
      rowGap: "normal",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      scrollTimelineAxis: "block",
      scrollTimelineName: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textEmphasisColor: "rgb(33, 37, 41)",
      textEmphasisPosition: "over",
      textEmphasisStyle: "none",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      textWrapMode: "wrap",
      textWrapStyle: "auto",
      timelineScope: "none",
      top: "auto",
      touchAction: "auto",
      transform: "matrix(1, 0, 0, -1, -858.14, -49.79)",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionBehavior: "normal",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimelineAxis: "block",
      viewTimelineInset: "auto",
      viewTimelineName: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      whiteSpaceCollapse: "collapse",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      accentColor: "auto",
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      anchorScope: "none",
      animationComposition: "replace",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationRangeEnd: "normal",
      animationRangeStart: "normal",
      animationTimeline: "auto",
      animationTimingFunction: "ease",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxDecorationBreak: "slice",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      containIntrinsicBlockSize: "none",
      containIntrinsicHeight: "none",
      containIntrinsicInlineSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicWidth: "none",
      containerName: "none",
      containerType: "normal",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "&quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: 16,
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesisSmallCaps: "auto",
      fontSynthesisStyle: "auto",
      fontSynthesisWeight: "auto",
      fontVariant: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantEmoji: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      interpolateSize: "numeric-only",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskClip: "border-box",
      maskComposite: "add",
      maskImage: "none",
      maskMode: "match-source",
      maskOrigin: "border-box",
      maskPosition: "0% 0%",
      maskRepeat: "repeat",
      maskSize: "auto",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offsetAnchor: "auto",
      offsetDistance: 0,
      offsetPath: "none",
      offsetPosition: "normal",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "50% 50%",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionArea: "none",
      positionTryFallbacks: "none",
      positionTryOrder: "normal",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      right: "auto",
      rotate: "none",
      rowGap: "normal",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      scrollTimelineAxis: "block",
      scrollTimelineName: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(147, 253, 147)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textEmphasisColor: "rgb(33, 37, 41)",
      textEmphasisPosition: "over",
      textEmphasisStyle: "none",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      textWrapMode: "wrap",
      textWrapStyle: "auto",
      timelineScope: "none",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionBehavior: "normal",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimelineAxis: "block",
      viewTimelineInset: "auto",
      viewTimelineName: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      whiteSpaceCollapse: "collapse",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      accentColor: "auto",
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      anchorScope: "none",
      animationComposition: "replace",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationRangeEnd: "normal",
      animationRangeStart: "normal",
      animationTimeline: "auto",
      animationTimingFunction: "ease",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxDecorationBreak: "slice",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      containIntrinsicBlockSize: "none",
      containIntrinsicHeight: "none",
      containIntrinsicInlineSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicWidth: "none",
      containerName: "none",
      containerType: "normal",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "&quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: 16,
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesisSmallCaps: "auto",
      fontSynthesisStyle: "auto",
      fontSynthesisWeight: "auto",
      fontVariant: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantEmoji: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      interpolateSize: "numeric-only",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskClip: "border-box",
      maskComposite: "add",
      maskImage: "none",
      maskMode: "match-source",
      maskOrigin: "border-box",
      maskPosition: "0% 0%",
      maskRepeat: "repeat",
      maskSize: "auto",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offsetAnchor: "auto",
      offsetDistance: 0,
      offsetPath: "none",
      offsetPosition: "normal",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "50% 50%",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionArea: "none",
      positionTryFallbacks: "none",
      positionTryOrder: "normal",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      right: "auto",
      rotate: "none",
      rowGap: "normal",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      scrollTimelineAxis: "block",
      scrollTimelineName: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(33, 194, 193)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textEmphasisColor: "rgb(33, 37, 41)",
      textEmphasisPosition: "over",
      textEmphasisStyle: "none",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      textWrapMode: "wrap",
      textWrapStyle: "auto",
      timelineScope: "none",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionBehavior: "normal",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimelineAxis: "block",
      viewTimelineInset: "auto",
      viewTimelineName: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      whiteSpaceCollapse: "collapse",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      accentColor: "auto",
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      anchorScope: "none",
      animationComposition: "replace",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationRangeEnd: "normal",
      animationRangeStart: "normal",
      animationTimeline: "auto",
      animationTimingFunction: "ease",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxDecorationBreak: "slice",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      containIntrinsicBlockSize: "none",
      containIntrinsicHeight: "none",
      containIntrinsicInlineSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicWidth: "none",
      containerName: "none",
      containerType: "normal",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "&quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: 16,
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesisSmallCaps: "auto",
      fontSynthesisStyle: "auto",
      fontSynthesisWeight: "auto",
      fontVariant: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantEmoji: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      interpolateSize: "numeric-only",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskClip: "border-box",
      maskComposite: "add",
      maskImage: "none",
      maskMode: "match-source",
      maskOrigin: "border-box",
      maskPosition: "0% 0%",
      maskRepeat: "repeat",
      maskSize: "auto",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offsetAnchor: "auto",
      offsetDistance: 0,
      offsetPath: "none",
      offsetPosition: "normal",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "50% 50%",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionArea: "none",
      positionTryFallbacks: "none",
      positionTryOrder: "normal",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      right: "auto",
      rotate: "none",
      rowGap: "normal",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      scrollTimelineAxis: "block",
      scrollTimelineName: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(132, 245, 153)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textEmphasisColor: "rgb(33, 37, 41)",
      textEmphasisPosition: "over",
      textEmphasisStyle: "none",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      textWrapMode: "wrap",
      textWrapStyle: "auto",
      timelineScope: "none",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionBehavior: "normal",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimelineAxis: "block",
      viewTimelineInset: "auto",
      viewTimelineName: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      whiteSpaceCollapse: "collapse",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      accentColor: "auto",
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      anchorScope: "none",
      animationComposition: "replace",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationRangeEnd: "normal",
      animationRangeStart: "normal",
      animationTimeline: "auto",
      animationTimingFunction: "ease",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxDecorationBreak: "slice",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      containIntrinsicBlockSize: "none",
      containIntrinsicHeight: "none",
      containIntrinsicInlineSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicWidth: "none",
      containerName: "none",
      containerType: "normal",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "path(&quot",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "url(&quot",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "&quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: 16,
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesisSmallCaps: "auto",
      fontSynthesisStyle: "auto",
      fontSynthesisWeight: "auto",
      fontVariant: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantEmoji: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      interpolateSize: "numeric-only",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskClip: "border-box",
      maskComposite: "add",
      maskImage: "none",
      maskMode: "match-source",
      maskOrigin: "border-box",
      maskPosition: "0% 0%",
      maskRepeat: "repeat",
      maskSize: "auto",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offsetAnchor: "auto",
      offsetDistance: 0,
      offsetPath: "none",
      offsetPosition: "normal",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionArea: "none",
      positionTryFallbacks: "none",
      positionTryOrder: "normal",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      right: "auto",
      rotate: "none",
      rowGap: "normal",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      scrollTimelineAxis: "block",
      scrollTimelineName: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textEmphasisColor: "rgb(33, 37, 41)",
      textEmphasisPosition: "over",
      textEmphasisStyle: "none",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      textWrapMode: "wrap",
      textWrapStyle: "auto",
      timelineScope: "none",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionBehavior: "normal",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimelineAxis: "block",
      viewTimelineInset: "auto",
      viewTimelineName: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      whiteSpaceCollapse: "collapse",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    },
    d: "M136.5,233.5c0,0,11.7-63.7-50-97.8S21.9,102,9.7,98.1c-7-2.4-14.2,2.6-6.1,12.8s3.5,12.8,19.7,17.3       s18.7,24.3,26.8,29.2c8.1,4.9,15.2,6.2,40,16.9c22.5,9.7,41.7,37.1,41.7,46.8s22,12.9,22,12.9L136.5,233.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "leaf-2",
    gradientUnits: "userSpaceOnUse",
    x1: 915.7653,
    y1: -166.9856,
    x2: 1003.1454,
    y2: -274.1156,
    gradientTransform: "matrix(1 0 0 -1 -858.14 -49.79)",
    style: {
      accentColor: "auto",
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      anchorScope: "none",
      animationComposition: "replace",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationRangeEnd: "normal",
      animationRangeStart: "normal",
      animationTimeline: "auto",
      animationTimingFunction: "ease",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxDecorationBreak: "slice",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      containIntrinsicBlockSize: "none",
      containIntrinsicHeight: "none",
      containIntrinsicInlineSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicWidth: "none",
      containerName: "none",
      containerType: "normal",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "&quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: 16,
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesisSmallCaps: "auto",
      fontSynthesisStyle: "auto",
      fontSynthesisWeight: "auto",
      fontVariant: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantEmoji: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      interpolateSize: "numeric-only",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskClip: "border-box",
      maskComposite: "add",
      maskImage: "none",
      maskMode: "match-source",
      maskOrigin: "border-box",
      maskPosition: "0% 0%",
      maskRepeat: "repeat",
      maskSize: "auto",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offsetAnchor: "auto",
      offsetDistance: 0,
      offsetPath: "none",
      offsetPosition: "normal",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionArea: "none",
      positionTryFallbacks: "none",
      positionTryOrder: "normal",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      right: "auto",
      rotate: "none",
      rowGap: "normal",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      scrollTimelineAxis: "block",
      scrollTimelineName: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textEmphasisColor: "rgb(33, 37, 41)",
      textEmphasisPosition: "over",
      textEmphasisStyle: "none",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      textWrapMode: "wrap",
      textWrapStyle: "auto",
      timelineScope: "none",
      top: "auto",
      touchAction: "auto",
      transform: "matrix(1, 0, 0, -1, -858.14, -49.79)",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionBehavior: "normal",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimelineAxis: "block",
      viewTimelineInset: "auto",
      viewTimelineName: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      whiteSpaceCollapse: "collapse",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      accentColor: "auto",
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      anchorScope: "none",
      animationComposition: "replace",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationRangeEnd: "normal",
      animationRangeStart: "normal",
      animationTimeline: "auto",
      animationTimingFunction: "ease",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxDecorationBreak: "slice",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      containIntrinsicBlockSize: "none",
      containIntrinsicHeight: "none",
      containIntrinsicInlineSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicWidth: "none",
      containerName: "none",
      containerType: "normal",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "&quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: 16,
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesisSmallCaps: "auto",
      fontSynthesisStyle: "auto",
      fontSynthesisWeight: "auto",
      fontVariant: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantEmoji: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      interpolateSize: "numeric-only",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskClip: "border-box",
      maskComposite: "add",
      maskImage: "none",
      maskMode: "match-source",
      maskOrigin: "border-box",
      maskPosition: "0% 0%",
      maskRepeat: "repeat",
      maskSize: "auto",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offsetAnchor: "auto",
      offsetDistance: 0,
      offsetPath: "none",
      offsetPosition: "normal",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "50% 50%",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionArea: "none",
      positionTryFallbacks: "none",
      positionTryOrder: "normal",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      right: "auto",
      rotate: "none",
      rowGap: "normal",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      scrollTimelineAxis: "block",
      scrollTimelineName: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(147, 253, 147)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textEmphasisColor: "rgb(33, 37, 41)",
      textEmphasisPosition: "over",
      textEmphasisStyle: "none",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      textWrapMode: "wrap",
      textWrapStyle: "auto",
      timelineScope: "none",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionBehavior: "normal",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimelineAxis: "block",
      viewTimelineInset: "auto",
      viewTimelineName: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      whiteSpaceCollapse: "collapse",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      accentColor: "auto",
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      anchorScope: "none",
      animationComposition: "replace",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationRangeEnd: "normal",
      animationRangeStart: "normal",
      animationTimeline: "auto",
      animationTimingFunction: "ease",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxDecorationBreak: "slice",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      containIntrinsicBlockSize: "none",
      containIntrinsicHeight: "none",
      containIntrinsicInlineSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicWidth: "none",
      containerName: "none",
      containerType: "normal",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "&quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: 16,
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesisSmallCaps: "auto",
      fontSynthesisStyle: "auto",
      fontSynthesisWeight: "auto",
      fontVariant: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantEmoji: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      interpolateSize: "numeric-only",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskClip: "border-box",
      maskComposite: "add",
      maskImage: "none",
      maskMode: "match-source",
      maskOrigin: "border-box",
      maskPosition: "0% 0%",
      maskRepeat: "repeat",
      maskSize: "auto",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offsetAnchor: "auto",
      offsetDistance: 0,
      offsetPath: "none",
      offsetPosition: "normal",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "50% 50%",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionArea: "none",
      positionTryFallbacks: "none",
      positionTryOrder: "normal",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      right: "auto",
      rotate: "none",
      rowGap: "normal",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      scrollTimelineAxis: "block",
      scrollTimelineName: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(33, 194, 193)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textEmphasisColor: "rgb(33, 37, 41)",
      textEmphasisPosition: "over",
      textEmphasisStyle: "none",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      textWrapMode: "wrap",
      textWrapStyle: "auto",
      timelineScope: "none",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionBehavior: "normal",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimelineAxis: "block",
      viewTimelineInset: "auto",
      viewTimelineName: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      whiteSpaceCollapse: "collapse",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      accentColor: "auto",
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      anchorScope: "none",
      animationComposition: "replace",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationRangeEnd: "normal",
      animationRangeStart: "normal",
      animationTimeline: "auto",
      animationTimingFunction: "ease",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxDecorationBreak: "slice",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      containIntrinsicBlockSize: "none",
      containIntrinsicHeight: "none",
      containIntrinsicInlineSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicWidth: "none",
      containerName: "none",
      containerType: "normal",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "&quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: 16,
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesisSmallCaps: "auto",
      fontSynthesisStyle: "auto",
      fontSynthesisWeight: "auto",
      fontVariant: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantEmoji: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      interpolateSize: "numeric-only",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskClip: "border-box",
      maskComposite: "add",
      maskImage: "none",
      maskMode: "match-source",
      maskOrigin: "border-box",
      maskPosition: "0% 0%",
      maskRepeat: "repeat",
      maskSize: "auto",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offsetAnchor: "auto",
      offsetDistance: 0,
      offsetPath: "none",
      offsetPosition: "normal",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "50% 50%",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionArea: "none",
      positionTryFallbacks: "none",
      positionTryOrder: "normal",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      right: "auto",
      rotate: "none",
      rowGap: "normal",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      scrollTimelineAxis: "block",
      scrollTimelineName: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(132, 245, 153)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textEmphasisColor: "rgb(33, 37, 41)",
      textEmphasisPosition: "over",
      textEmphasisStyle: "none",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      textWrapMode: "wrap",
      textWrapStyle: "auto",
      timelineScope: "none",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionBehavior: "normal",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimelineAxis: "block",
      viewTimelineInset: "auto",
      viewTimelineName: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      whiteSpaceCollapse: "collapse",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      accentColor: "auto",
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      anchorScope: "none",
      animationComposition: "replace",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationRangeEnd: "normal",
      animationRangeStart: "normal",
      animationTimeline: "auto",
      animationTimingFunction: "ease",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxDecorationBreak: "slice",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      containIntrinsicBlockSize: "none",
      containIntrinsicHeight: "none",
      containIntrinsicInlineSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicWidth: "none",
      containerName: "none",
      containerType: "normal",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "path(&quot",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "url(&quot",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "&quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: 16,
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesisSmallCaps: "auto",
      fontSynthesisStyle: "auto",
      fontSynthesisWeight: "auto",
      fontVariant: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantEmoji: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      interpolateSize: "numeric-only",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskClip: "border-box",
      maskComposite: "add",
      maskImage: "none",
      maskMode: "match-source",
      maskOrigin: "border-box",
      maskPosition: "0% 0%",
      maskRepeat: "repeat",
      maskSize: "auto",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offsetAnchor: "auto",
      offsetDistance: 0,
      offsetPath: "none",
      offsetPosition: "normal",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionArea: "none",
      positionTryFallbacks: "none",
      positionTryOrder: "normal",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      right: "auto",
      rotate: "none",
      rowGap: "normal",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      scrollTimelineAxis: "block",
      scrollTimelineName: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textEmphasisColor: "rgb(33, 37, 41)",
      textEmphasisPosition: "over",
      textEmphasisStyle: "none",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      textWrapMode: "wrap",
      textWrapStyle: "auto",
      timelineScope: "none",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionBehavior: "normal",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimelineAxis: "block",
      viewTimelineInset: "auto",
      viewTimelineName: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      whiteSpaceCollapse: "collapse",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    },
    d: "M134.3,224.6c0,0,15.7-58.6-38.3-90.3S23.1,103,12.4,99.2C6.3,97,23.1,104.6,30.1,114s5.3,7.3,18,14.3       c14.7,8.1,20.8,16,29.4,17.6c12.5,2.4,8.8,15.4,30.5,25.2c19.6,8.9,22.1,32.7,22.1,41.7s19.2,12,19.2,12L134.3,224.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "leaf-3",
    gradientUnits: "userSpaceOnUse",
    x1: 1016.4244,
    y1: -288.1557,
    x2: 1136.5544,
    y2: -195.2057,
    gradientTransform: "matrix(1 0 0 -1 -858.14 -49.79)",
    style: {
      accentColor: "auto",
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      anchorScope: "none",
      animationComposition: "replace",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationRangeEnd: "normal",
      animationRangeStart: "normal",
      animationTimeline: "auto",
      animationTimingFunction: "ease",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxDecorationBreak: "slice",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      containIntrinsicBlockSize: "none",
      containIntrinsicHeight: "none",
      containIntrinsicInlineSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicWidth: "none",
      containerName: "none",
      containerType: "normal",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "&quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: 16,
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesisSmallCaps: "auto",
      fontSynthesisStyle: "auto",
      fontSynthesisWeight: "auto",
      fontVariant: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantEmoji: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      interpolateSize: "numeric-only",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskClip: "border-box",
      maskComposite: "add",
      maskImage: "none",
      maskMode: "match-source",
      maskOrigin: "border-box",
      maskPosition: "0% 0%",
      maskRepeat: "repeat",
      maskSize: "auto",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offsetAnchor: "auto",
      offsetDistance: 0,
      offsetPath: "none",
      offsetPosition: "normal",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionArea: "none",
      positionTryFallbacks: "none",
      positionTryOrder: "normal",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      right: "auto",
      rotate: "none",
      rowGap: "normal",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      scrollTimelineAxis: "block",
      scrollTimelineName: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textEmphasisColor: "rgb(33, 37, 41)",
      textEmphasisPosition: "over",
      textEmphasisStyle: "none",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      textWrapMode: "wrap",
      textWrapStyle: "auto",
      timelineScope: "none",
      top: "auto",
      touchAction: "auto",
      transform: "matrix(1, 0, 0, -1, -858.14, -49.79)",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionBehavior: "normal",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimelineAxis: "block",
      viewTimelineInset: "auto",
      viewTimelineName: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      whiteSpaceCollapse: "collapse",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      accentColor: "auto",
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      anchorScope: "none",
      animationComposition: "replace",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationRangeEnd: "normal",
      animationRangeStart: "normal",
      animationTimeline: "auto",
      animationTimingFunction: "ease",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxDecorationBreak: "slice",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      containIntrinsicBlockSize: "none",
      containIntrinsicHeight: "none",
      containIntrinsicInlineSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicWidth: "none",
      containerName: "none",
      containerType: "normal",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "&quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: 16,
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesisSmallCaps: "auto",
      fontSynthesisStyle: "auto",
      fontSynthesisWeight: "auto",
      fontVariant: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantEmoji: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      interpolateSize: "numeric-only",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskClip: "border-box",
      maskComposite: "add",
      maskImage: "none",
      maskMode: "match-source",
      maskOrigin: "border-box",
      maskPosition: "0% 0%",
      maskRepeat: "repeat",
      maskSize: "auto",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offsetAnchor: "auto",
      offsetDistance: 0,
      offsetPath: "none",
      offsetPosition: "normal",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "50% 50%",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionArea: "none",
      positionTryFallbacks: "none",
      positionTryOrder: "normal",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      right: "auto",
      rotate: "none",
      rowGap: "normal",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      scrollTimelineAxis: "block",
      scrollTimelineName: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(147, 253, 147)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textEmphasisColor: "rgb(33, 37, 41)",
      textEmphasisPosition: "over",
      textEmphasisStyle: "none",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      textWrapMode: "wrap",
      textWrapStyle: "auto",
      timelineScope: "none",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionBehavior: "normal",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimelineAxis: "block",
      viewTimelineInset: "auto",
      viewTimelineName: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      whiteSpaceCollapse: "collapse",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      accentColor: "auto",
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      anchorScope: "none",
      animationComposition: "replace",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationRangeEnd: "normal",
      animationRangeStart: "normal",
      animationTimeline: "auto",
      animationTimingFunction: "ease",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxDecorationBreak: "slice",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      containIntrinsicBlockSize: "none",
      containIntrinsicHeight: "none",
      containIntrinsicInlineSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicWidth: "none",
      containerName: "none",
      containerType: "normal",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "&quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: 16,
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesisSmallCaps: "auto",
      fontSynthesisStyle: "auto",
      fontSynthesisWeight: "auto",
      fontVariant: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantEmoji: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      interpolateSize: "numeric-only",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskClip: "border-box",
      maskComposite: "add",
      maskImage: "none",
      maskMode: "match-source",
      maskOrigin: "border-box",
      maskPosition: "0% 0%",
      maskRepeat: "repeat",
      maskSize: "auto",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offsetAnchor: "auto",
      offsetDistance: 0,
      offsetPath: "none",
      offsetPosition: "normal",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "50% 50%",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionArea: "none",
      positionTryFallbacks: "none",
      positionTryOrder: "normal",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      right: "auto",
      rotate: "none",
      rowGap: "normal",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      scrollTimelineAxis: "block",
      scrollTimelineName: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(33, 194, 193)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textEmphasisColor: "rgb(33, 37, 41)",
      textEmphasisPosition: "over",
      textEmphasisStyle: "none",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      textWrapMode: "wrap",
      textWrapStyle: "auto",
      timelineScope: "none",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionBehavior: "normal",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimelineAxis: "block",
      viewTimelineInset: "auto",
      viewTimelineName: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      whiteSpaceCollapse: "collapse",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      accentColor: "auto",
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      anchorScope: "none",
      animationComposition: "replace",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationRangeEnd: "normal",
      animationRangeStart: "normal",
      animationTimeline: "auto",
      animationTimingFunction: "ease",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxDecorationBreak: "slice",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      containIntrinsicBlockSize: "none",
      containIntrinsicHeight: "none",
      containIntrinsicInlineSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicWidth: "none",
      containerName: "none",
      containerType: "normal",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "&quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: 16,
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesisSmallCaps: "auto",
      fontSynthesisStyle: "auto",
      fontSynthesisWeight: "auto",
      fontVariant: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantEmoji: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      interpolateSize: "numeric-only",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskClip: "border-box",
      maskComposite: "add",
      maskImage: "none",
      maskMode: "match-source",
      maskOrigin: "border-box",
      maskPosition: "0% 0%",
      maskRepeat: "repeat",
      maskSize: "auto",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offsetAnchor: "auto",
      offsetDistance: 0,
      offsetPath: "none",
      offsetPosition: "normal",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "50% 50%",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionArea: "none",
      positionTryFallbacks: "none",
      positionTryOrder: "normal",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      right: "auto",
      rotate: "none",
      rowGap: "normal",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      scrollTimelineAxis: "block",
      scrollTimelineName: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(132, 245, 153)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textEmphasisColor: "rgb(33, 37, 41)",
      textEmphasisPosition: "over",
      textEmphasisStyle: "none",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      textWrapMode: "wrap",
      textWrapStyle: "auto",
      timelineScope: "none",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionBehavior: "normal",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimelineAxis: "block",
      viewTimelineInset: "auto",
      viewTimelineName: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      whiteSpaceCollapse: "collapse",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      accentColor: "auto",
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      anchorScope: "none",
      animationComposition: "replace",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationRangeEnd: "normal",
      animationRangeStart: "normal",
      animationTimeline: "auto",
      animationTimingFunction: "ease",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxDecorationBreak: "slice",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      containIntrinsicBlockSize: "none",
      containIntrinsicHeight: "none",
      containIntrinsicInlineSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicWidth: "none",
      containerName: "none",
      containerType: "normal",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "path(&quot",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "url(&quot",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "&quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: 16,
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesisSmallCaps: "auto",
      fontSynthesisStyle: "auto",
      fontSynthesisWeight: "auto",
      fontVariant: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantEmoji: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      interpolateSize: "numeric-only",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskClip: "border-box",
      maskComposite: "add",
      maskImage: "none",
      maskMode: "match-source",
      maskOrigin: "border-box",
      maskPosition: "0% 0%",
      maskRepeat: "repeat",
      maskSize: "auto",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offsetAnchor: "auto",
      offsetDistance: 0,
      offsetPath: "none",
      offsetPosition: "normal",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionArea: "none",
      positionTryFallbacks: "none",
      positionTryOrder: "normal",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      right: "auto",
      rotate: "none",
      rowGap: "normal",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      scrollTimelineAxis: "block",
      scrollTimelineName: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textEmphasisColor: "rgb(33, 37, 41)",
      textEmphasisPosition: "over",
      textEmphasisStyle: "none",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      textWrapMode: "wrap",
      textWrapStyle: "auto",
      timelineScope: "none",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionBehavior: "normal",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimelineAxis: "block",
      viewTimelineInset: "auto",
      viewTimelineName: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      whiteSpaceCollapse: "collapse",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    },
    d: "M188.7,216l6.1-5.8c2.9-2.7,6.5-4.7,10.4-5.7c19.1-5,79.1-23.8,104-69.2c0.2-0.4,0-0.9-0.4-1.1       c0,0-0.1,0-0.1,0c-0.1,0-0.2-0.1-0.3-0.1c-8.3-0.6-51-1.3-108.1,47.4c-1,0.8-2,1.8-2.8,2.8c-1.4,2-3.8,5.4-4.9,7.2       c-1.5,2.6,1.5,7-2.5,10.9S177.5,216,177.5,216l7,5.2L188.7,216z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "leaf-4",
    gradientUnits: "userSpaceOnUse",
    x1: 1046.6136,
    y1: -240.8951,
    x2: 943.4336,
    y2: -110.275,
    gradientTransform: "matrix(1 0 0 -1 -858.14 -49.79)",
    style: {
      accentColor: "auto",
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      anchorScope: "none",
      animationComposition: "replace",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationRangeEnd: "normal",
      animationRangeStart: "normal",
      animationTimeline: "auto",
      animationTimingFunction: "ease",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxDecorationBreak: "slice",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      containIntrinsicBlockSize: "none",
      containIntrinsicHeight: "none",
      containIntrinsicInlineSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicWidth: "none",
      containerName: "none",
      containerType: "normal",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "&quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: 16,
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesisSmallCaps: "auto",
      fontSynthesisStyle: "auto",
      fontSynthesisWeight: "auto",
      fontVariant: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantEmoji: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      interpolateSize: "numeric-only",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskClip: "border-box",
      maskComposite: "add",
      maskImage: "none",
      maskMode: "match-source",
      maskOrigin: "border-box",
      maskPosition: "0% 0%",
      maskRepeat: "repeat",
      maskSize: "auto",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offsetAnchor: "auto",
      offsetDistance: 0,
      offsetPath: "none",
      offsetPosition: "normal",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionArea: "none",
      positionTryFallbacks: "none",
      positionTryOrder: "normal",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      right: "auto",
      rotate: "none",
      rowGap: "normal",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      scrollTimelineAxis: "block",
      scrollTimelineName: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textEmphasisColor: "rgb(33, 37, 41)",
      textEmphasisPosition: "over",
      textEmphasisStyle: "none",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      textWrapMode: "wrap",
      textWrapStyle: "auto",
      timelineScope: "none",
      top: "auto",
      touchAction: "auto",
      transform: "matrix(1, 0, 0, -1, -858.14, -49.79)",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionBehavior: "normal",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimelineAxis: "block",
      viewTimelineInset: "auto",
      viewTimelineName: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      whiteSpaceCollapse: "collapse",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      accentColor: "auto",
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      anchorScope: "none",
      animationComposition: "replace",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationRangeEnd: "normal",
      animationRangeStart: "normal",
      animationTimeline: "auto",
      animationTimingFunction: "ease",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxDecorationBreak: "slice",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      containIntrinsicBlockSize: "none",
      containIntrinsicHeight: "none",
      containIntrinsicInlineSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicWidth: "none",
      containerName: "none",
      containerType: "normal",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "&quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: 16,
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesisSmallCaps: "auto",
      fontSynthesisStyle: "auto",
      fontSynthesisWeight: "auto",
      fontVariant: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantEmoji: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      interpolateSize: "numeric-only",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskClip: "border-box",
      maskComposite: "add",
      maskImage: "none",
      maskMode: "match-source",
      maskOrigin: "border-box",
      maskPosition: "0% 0%",
      maskRepeat: "repeat",
      maskSize: "auto",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offsetAnchor: "auto",
      offsetDistance: 0,
      offsetPath: "none",
      offsetPosition: "normal",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "50% 50%",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionArea: "none",
      positionTryFallbacks: "none",
      positionTryOrder: "normal",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      right: "auto",
      rotate: "none",
      rowGap: "normal",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      scrollTimelineAxis: "block",
      scrollTimelineName: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(147, 253, 147)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textEmphasisColor: "rgb(33, 37, 41)",
      textEmphasisPosition: "over",
      textEmphasisStyle: "none",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      textWrapMode: "wrap",
      textWrapStyle: "auto",
      timelineScope: "none",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionBehavior: "normal",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimelineAxis: "block",
      viewTimelineInset: "auto",
      viewTimelineName: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      whiteSpaceCollapse: "collapse",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      accentColor: "auto",
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      anchorScope: "none",
      animationComposition: "replace",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationRangeEnd: "normal",
      animationRangeStart: "normal",
      animationTimeline: "auto",
      animationTimingFunction: "ease",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxDecorationBreak: "slice",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      containIntrinsicBlockSize: "none",
      containIntrinsicHeight: "none",
      containIntrinsicInlineSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicWidth: "none",
      containerName: "none",
      containerType: "normal",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "&quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: 16,
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesisSmallCaps: "auto",
      fontSynthesisStyle: "auto",
      fontSynthesisWeight: "auto",
      fontVariant: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantEmoji: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      interpolateSize: "numeric-only",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskClip: "border-box",
      maskComposite: "add",
      maskImage: "none",
      maskMode: "match-source",
      maskOrigin: "border-box",
      maskPosition: "0% 0%",
      maskRepeat: "repeat",
      maskSize: "auto",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offsetAnchor: "auto",
      offsetDistance: 0,
      offsetPath: "none",
      offsetPosition: "normal",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "50% 50%",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionArea: "none",
      positionTryFallbacks: "none",
      positionTryOrder: "normal",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      right: "auto",
      rotate: "none",
      rowGap: "normal",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      scrollTimelineAxis: "block",
      scrollTimelineName: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(33, 194, 193)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textEmphasisColor: "rgb(33, 37, 41)",
      textEmphasisPosition: "over",
      textEmphasisStyle: "none",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      textWrapMode: "wrap",
      textWrapStyle: "auto",
      timelineScope: "none",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionBehavior: "normal",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimelineAxis: "block",
      viewTimelineInset: "auto",
      viewTimelineName: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      whiteSpaceCollapse: "collapse",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      accentColor: "auto",
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      anchorScope: "none",
      animationComposition: "replace",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationRangeEnd: "normal",
      animationRangeStart: "normal",
      animationTimeline: "auto",
      animationTimingFunction: "ease",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxDecorationBreak: "slice",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      containIntrinsicBlockSize: "none",
      containIntrinsicHeight: "none",
      containIntrinsicInlineSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicWidth: "none",
      containerName: "none",
      containerType: "normal",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "&quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: 16,
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesisSmallCaps: "auto",
      fontSynthesisStyle: "auto",
      fontSynthesisWeight: "auto",
      fontVariant: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantEmoji: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      interpolateSize: "numeric-only",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskClip: "border-box",
      maskComposite: "add",
      maskImage: "none",
      maskMode: "match-source",
      maskOrigin: "border-box",
      maskPosition: "0% 0%",
      maskRepeat: "repeat",
      maskSize: "auto",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offsetAnchor: "auto",
      offsetDistance: 0,
      offsetPath: "none",
      offsetPosition: "normal",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "50% 50%",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionArea: "none",
      positionTryFallbacks: "none",
      positionTryOrder: "normal",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      right: "auto",
      rotate: "none",
      rowGap: "normal",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      scrollTimelineAxis: "block",
      scrollTimelineName: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(132, 245, 153)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textEmphasisColor: "rgb(33, 37, 41)",
      textEmphasisPosition: "over",
      textEmphasisStyle: "none",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      textWrapMode: "wrap",
      textWrapStyle: "auto",
      timelineScope: "none",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionBehavior: "normal",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimelineAxis: "block",
      viewTimelineInset: "auto",
      viewTimelineName: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      whiteSpaceCollapse: "collapse",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      accentColor: "auto",
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      anchorScope: "none",
      animationComposition: "replace",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationRangeEnd: "normal",
      animationRangeStart: "normal",
      animationTimeline: "auto",
      animationTimingFunction: "ease",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxDecorationBreak: "slice",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      containIntrinsicBlockSize: "none",
      containIntrinsicHeight: "none",
      containIntrinsicInlineSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicWidth: "none",
      containerName: "none",
      containerType: "normal",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "path(&quot",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "url(&quot",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "&quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: 16,
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesisSmallCaps: "auto",
      fontSynthesisStyle: "auto",
      fontSynthesisWeight: "auto",
      fontVariant: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantEmoji: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      interpolateSize: "numeric-only",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskClip: "border-box",
      maskComposite: "add",
      maskImage: "none",
      maskMode: "match-source",
      maskOrigin: "border-box",
      maskPosition: "0% 0%",
      maskRepeat: "repeat",
      maskSize: "auto",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offsetAnchor: "auto",
      offsetDistance: 0,
      offsetPath: "none",
      offsetPosition: "normal",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionArea: "none",
      positionTryFallbacks: "none",
      positionTryOrder: "normal",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      right: "auto",
      rotate: "none",
      rowGap: "normal",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      scrollTimelineAxis: "block",
      scrollTimelineName: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textEmphasisColor: "rgb(33, 37, 41)",
      textEmphasisPosition: "over",
      textEmphasisStyle: "none",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      textWrapMode: "wrap",
      textWrapStyle: "auto",
      timelineScope: "none",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionBehavior: "normal",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimelineAxis: "block",
      viewTimelineInset: "auto",
      viewTimelineName: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      whiteSpaceCollapse: "collapse",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    },
    d: "M156.2,212.2c0,0,16.4-146.6-28.3-192.7c-41.2-42.4-41.8-3.4-41.7,3.2c0,0.6,0.2,1.1,0.4,1.6       c9.7,18.1,13.1,39,9.6,59.2c-4.2,21.2,26.1,18.4,28.7,39.3s13.2,53.1,12.1,67.9s-1.2,29.2-1.2,29.2l16.5,0.5L156.2,212.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "leaf-5",
    gradientUnits: "userSpaceOnUse",
    x1: 944.728,
    y1: -159.9609,
    x2: 1017.3268,
    y2: -159.9609,
    gradientTransform: "matrix(1 0 0 -1 -858.14 -49.79)",
    style: {
      accentColor: "auto",
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      anchorScope: "none",
      animationComposition: "replace",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationRangeEnd: "normal",
      animationRangeStart: "normal",
      animationTimeline: "auto",
      animationTimingFunction: "ease",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxDecorationBreak: "slice",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      containIntrinsicBlockSize: "none",
      containIntrinsicHeight: "none",
      containIntrinsicInlineSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicWidth: "none",
      containerName: "none",
      containerType: "normal",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "&quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: 16,
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesisSmallCaps: "auto",
      fontSynthesisStyle: "auto",
      fontSynthesisWeight: "auto",
      fontVariant: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantEmoji: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      interpolateSize: "numeric-only",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskClip: "border-box",
      maskComposite: "add",
      maskImage: "none",
      maskMode: "match-source",
      maskOrigin: "border-box",
      maskPosition: "0% 0%",
      maskRepeat: "repeat",
      maskSize: "auto",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offsetAnchor: "auto",
      offsetDistance: 0,
      offsetPath: "none",
      offsetPosition: "normal",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionArea: "none",
      positionTryFallbacks: "none",
      positionTryOrder: "normal",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      right: "auto",
      rotate: "none",
      rowGap: "normal",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      scrollTimelineAxis: "block",
      scrollTimelineName: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textEmphasisColor: "rgb(33, 37, 41)",
      textEmphasisPosition: "over",
      textEmphasisStyle: "none",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      textWrapMode: "wrap",
      textWrapStyle: "auto",
      timelineScope: "none",
      top: "auto",
      touchAction: "auto",
      transform: "matrix(1, 0, 0, -1, -858.14, -49.79)",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionBehavior: "normal",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimelineAxis: "block",
      viewTimelineInset: "auto",
      viewTimelineName: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      whiteSpaceCollapse: "collapse",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      accentColor: "auto",
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      anchorScope: "none",
      animationComposition: "replace",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationRangeEnd: "normal",
      animationRangeStart: "normal",
      animationTimeline: "auto",
      animationTimingFunction: "ease",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxDecorationBreak: "slice",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      containIntrinsicBlockSize: "none",
      containIntrinsicHeight: "none",
      containIntrinsicInlineSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicWidth: "none",
      containerName: "none",
      containerType: "normal",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "&quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: 16,
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesisSmallCaps: "auto",
      fontSynthesisStyle: "auto",
      fontSynthesisWeight: "auto",
      fontVariant: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantEmoji: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      interpolateSize: "numeric-only",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskClip: "border-box",
      maskComposite: "add",
      maskImage: "none",
      maskMode: "match-source",
      maskOrigin: "border-box",
      maskPosition: "0% 0%",
      maskRepeat: "repeat",
      maskSize: "auto",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offsetAnchor: "auto",
      offsetDistance: 0,
      offsetPath: "none",
      offsetPosition: "normal",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "50% 50%",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionArea: "none",
      positionTryFallbacks: "none",
      positionTryOrder: "normal",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      right: "auto",
      rotate: "none",
      rowGap: "normal",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      scrollTimelineAxis: "block",
      scrollTimelineName: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(147, 253, 147)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textEmphasisColor: "rgb(33, 37, 41)",
      textEmphasisPosition: "over",
      textEmphasisStyle: "none",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      textWrapMode: "wrap",
      textWrapStyle: "auto",
      timelineScope: "none",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionBehavior: "normal",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimelineAxis: "block",
      viewTimelineInset: "auto",
      viewTimelineName: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      whiteSpaceCollapse: "collapse",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      accentColor: "auto",
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      anchorScope: "none",
      animationComposition: "replace",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationRangeEnd: "normal",
      animationRangeStart: "normal",
      animationTimeline: "auto",
      animationTimingFunction: "ease",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxDecorationBreak: "slice",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      containIntrinsicBlockSize: "none",
      containIntrinsicHeight: "none",
      containIntrinsicInlineSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicWidth: "none",
      containerName: "none",
      containerType: "normal",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "&quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: 16,
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesisSmallCaps: "auto",
      fontSynthesisStyle: "auto",
      fontSynthesisWeight: "auto",
      fontVariant: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantEmoji: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      interpolateSize: "numeric-only",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskClip: "border-box",
      maskComposite: "add",
      maskImage: "none",
      maskMode: "match-source",
      maskOrigin: "border-box",
      maskPosition: "0% 0%",
      maskRepeat: "repeat",
      maskSize: "auto",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offsetAnchor: "auto",
      offsetDistance: 0,
      offsetPath: "none",
      offsetPosition: "normal",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "50% 50%",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionArea: "none",
      positionTryFallbacks: "none",
      positionTryOrder: "normal",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      right: "auto",
      rotate: "none",
      rowGap: "normal",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      scrollTimelineAxis: "block",
      scrollTimelineName: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(33, 194, 193)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textEmphasisColor: "rgb(33, 37, 41)",
      textEmphasisPosition: "over",
      textEmphasisStyle: "none",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      textWrapMode: "wrap",
      textWrapStyle: "auto",
      timelineScope: "none",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionBehavior: "normal",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimelineAxis: "block",
      viewTimelineInset: "auto",
      viewTimelineName: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      whiteSpaceCollapse: "collapse",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      accentColor: "auto",
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      anchorScope: "none",
      animationComposition: "replace",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationRangeEnd: "normal",
      animationRangeStart: "normal",
      animationTimeline: "auto",
      animationTimingFunction: "ease",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxDecorationBreak: "slice",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      containIntrinsicBlockSize: "none",
      containIntrinsicHeight: "none",
      containIntrinsicInlineSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicWidth: "none",
      containerName: "none",
      containerType: "normal",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "&quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: 16,
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesisSmallCaps: "auto",
      fontSynthesisStyle: "auto",
      fontSynthesisWeight: "auto",
      fontVariant: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantEmoji: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      interpolateSize: "numeric-only",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskClip: "border-box",
      maskComposite: "add",
      maskImage: "none",
      maskMode: "match-source",
      maskOrigin: "border-box",
      maskPosition: "0% 0%",
      maskRepeat: "repeat",
      maskSize: "auto",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offsetAnchor: "auto",
      offsetDistance: 0,
      offsetPath: "none",
      offsetPosition: "normal",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "50% 50%",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionArea: "none",
      positionTryFallbacks: "none",
      positionTryOrder: "normal",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      right: "auto",
      rotate: "none",
      rowGap: "normal",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      scrollTimelineAxis: "block",
      scrollTimelineName: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(132, 245, 153)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textEmphasisColor: "rgb(33, 37, 41)",
      textEmphasisPosition: "over",
      textEmphasisStyle: "none",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      textWrapMode: "wrap",
      textWrapStyle: "auto",
      timelineScope: "none",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionBehavior: "normal",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimelineAxis: "block",
      viewTimelineInset: "auto",
      viewTimelineName: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      whiteSpaceCollapse: "collapse",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      accentColor: "auto",
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      anchorScope: "none",
      animationComposition: "replace",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationRangeEnd: "normal",
      animationRangeStart: "normal",
      animationTimeline: "auto",
      animationTimingFunction: "ease",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxDecorationBreak: "slice",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      containIntrinsicBlockSize: "none",
      containIntrinsicHeight: "none",
      containIntrinsicInlineSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicWidth: "none",
      containerName: "none",
      containerType: "normal",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "path(&quot",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "url(&quot",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "&quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: 16,
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesisSmallCaps: "auto",
      fontSynthesisStyle: "auto",
      fontSynthesisWeight: "auto",
      fontVariant: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantEmoji: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      interpolateSize: "numeric-only",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskClip: "border-box",
      maskComposite: "add",
      maskImage: "none",
      maskMode: "match-source",
      maskOrigin: "border-box",
      maskPosition: "0% 0%",
      maskRepeat: "repeat",
      maskSize: "auto",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offsetAnchor: "auto",
      offsetDistance: 0,
      offsetPath: "none",
      offsetPosition: "normal",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionArea: "none",
      positionTryFallbacks: "none",
      positionTryOrder: "normal",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      right: "auto",
      rotate: "none",
      rowGap: "normal",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      scrollTimelineAxis: "block",
      scrollTimelineName: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textEmphasisColor: "rgb(33, 37, 41)",
      textEmphasisPosition: "over",
      textEmphasisStyle: "none",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      textWrapMode: "wrap",
      textWrapStyle: "auto",
      timelineScope: "none",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionBehavior: "normal",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimelineAxis: "block",
      viewTimelineInset: "auto",
      viewTimelineName: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      whiteSpaceCollapse: "collapse",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    },
    d: "M156,212.7c0.1-0.3,0.2-0.7,0.3-1c1-9.6,14.8-147.7-28.4-192.2c-40.9-42.2-41.5-4-41.3,2.9       c0.1,0.8,0.5,1.6,0.9,2.3c3,4.4,16.5,23.6,28.5,21.4c33.1-5.9,3.9,33.9,21.9,55.2c14.4,16.8,9.6,74.8,8.5,89.7       c-0.7,8.4-2.1,16.6-4.2,24.8c-0.4,2.1,1,4.1,3,4.5c0.1,0,0.2,0,0.3,0c0.3,0,0.5,0.1,0.8,0.1h3c1.8,0.1,3.4-0.8,4.2-2.4L156,212.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "leaf-6",
    gradientUnits: "userSpaceOnUse",
    x1: 1011.0566,
    y1: -278.5484,
    x2: 1089.6967,
    y2: -164.8184,
    gradientTransform: "matrix(1 0 0 -1 -858.14 -49.79)",
    style: {
      accentColor: "auto",
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      anchorScope: "none",
      animationComposition: "replace",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationRangeEnd: "normal",
      animationRangeStart: "normal",
      animationTimeline: "auto",
      animationTimingFunction: "ease",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxDecorationBreak: "slice",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      containIntrinsicBlockSize: "none",
      containIntrinsicHeight: "none",
      containIntrinsicInlineSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicWidth: "none",
      containerName: "none",
      containerType: "normal",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "&quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: 16,
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesisSmallCaps: "auto",
      fontSynthesisStyle: "auto",
      fontSynthesisWeight: "auto",
      fontVariant: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantEmoji: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      interpolateSize: "numeric-only",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskClip: "border-box",
      maskComposite: "add",
      maskImage: "none",
      maskMode: "match-source",
      maskOrigin: "border-box",
      maskPosition: "0% 0%",
      maskRepeat: "repeat",
      maskSize: "auto",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offsetAnchor: "auto",
      offsetDistance: 0,
      offsetPath: "none",
      offsetPosition: "normal",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionArea: "none",
      positionTryFallbacks: "none",
      positionTryOrder: "normal",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      right: "auto",
      rotate: "none",
      rowGap: "normal",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      scrollTimelineAxis: "block",
      scrollTimelineName: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textEmphasisColor: "rgb(33, 37, 41)",
      textEmphasisPosition: "over",
      textEmphasisStyle: "none",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      textWrapMode: "wrap",
      textWrapStyle: "auto",
      timelineScope: "none",
      top: "auto",
      touchAction: "auto",
      transform: "matrix(1, 0, 0, -1, -858.14, -49.79)",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionBehavior: "normal",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimelineAxis: "block",
      viewTimelineInset: "auto",
      viewTimelineName: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      whiteSpaceCollapse: "collapse",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      accentColor: "auto",
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      anchorScope: "none",
      animationComposition: "replace",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationRangeEnd: "normal",
      animationRangeStart: "normal",
      animationTimeline: "auto",
      animationTimingFunction: "ease",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxDecorationBreak: "slice",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      containIntrinsicBlockSize: "none",
      containIntrinsicHeight: "none",
      containIntrinsicInlineSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicWidth: "none",
      containerName: "none",
      containerType: "normal",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "&quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: 16,
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesisSmallCaps: "auto",
      fontSynthesisStyle: "auto",
      fontSynthesisWeight: "auto",
      fontVariant: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantEmoji: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      interpolateSize: "numeric-only",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskClip: "border-box",
      maskComposite: "add",
      maskImage: "none",
      maskMode: "match-source",
      maskOrigin: "border-box",
      maskPosition: "0% 0%",
      maskRepeat: "repeat",
      maskSize: "auto",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offsetAnchor: "auto",
      offsetDistance: 0,
      offsetPath: "none",
      offsetPosition: "normal",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "50% 50%",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionArea: "none",
      positionTryFallbacks: "none",
      positionTryOrder: "normal",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      right: "auto",
      rotate: "none",
      rowGap: "normal",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      scrollTimelineAxis: "block",
      scrollTimelineName: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(147, 253, 147)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textEmphasisColor: "rgb(33, 37, 41)",
      textEmphasisPosition: "over",
      textEmphasisStyle: "none",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      textWrapMode: "wrap",
      textWrapStyle: "auto",
      timelineScope: "none",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionBehavior: "normal",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimelineAxis: "block",
      viewTimelineInset: "auto",
      viewTimelineName: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      whiteSpaceCollapse: "collapse",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      accentColor: "auto",
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      anchorScope: "none",
      animationComposition: "replace",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationRangeEnd: "normal",
      animationRangeStart: "normal",
      animationTimeline: "auto",
      animationTimingFunction: "ease",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxDecorationBreak: "slice",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      containIntrinsicBlockSize: "none",
      containIntrinsicHeight: "none",
      containIntrinsicInlineSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicWidth: "none",
      containerName: "none",
      containerType: "normal",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "&quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: 16,
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesisSmallCaps: "auto",
      fontSynthesisStyle: "auto",
      fontSynthesisWeight: "auto",
      fontVariant: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantEmoji: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      interpolateSize: "numeric-only",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskClip: "border-box",
      maskComposite: "add",
      maskImage: "none",
      maskMode: "match-source",
      maskOrigin: "border-box",
      maskPosition: "0% 0%",
      maskRepeat: "repeat",
      maskSize: "auto",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offsetAnchor: "auto",
      offsetDistance: 0,
      offsetPath: "none",
      offsetPosition: "normal",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "50% 50%",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionArea: "none",
      positionTryFallbacks: "none",
      positionTryOrder: "normal",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      right: "auto",
      rotate: "none",
      rowGap: "normal",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      scrollTimelineAxis: "block",
      scrollTimelineName: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(33, 194, 193)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textEmphasisColor: "rgb(33, 37, 41)",
      textEmphasisPosition: "over",
      textEmphasisStyle: "none",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      textWrapMode: "wrap",
      textWrapStyle: "auto",
      timelineScope: "none",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionBehavior: "normal",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimelineAxis: "block",
      viewTimelineInset: "auto",
      viewTimelineName: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      whiteSpaceCollapse: "collapse",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      accentColor: "auto",
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      anchorScope: "none",
      animationComposition: "replace",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationRangeEnd: "normal",
      animationRangeStart: "normal",
      animationTimeline: "auto",
      animationTimingFunction: "ease",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxDecorationBreak: "slice",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      containIntrinsicBlockSize: "none",
      containIntrinsicHeight: "none",
      containIntrinsicInlineSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicWidth: "none",
      containerName: "none",
      containerType: "normal",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "&quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: 16,
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesisSmallCaps: "auto",
      fontSynthesisStyle: "auto",
      fontSynthesisWeight: "auto",
      fontVariant: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantEmoji: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      interpolateSize: "numeric-only",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskClip: "border-box",
      maskComposite: "add",
      maskImage: "none",
      maskMode: "match-source",
      maskOrigin: "border-box",
      maskPosition: "0% 0%",
      maskRepeat: "repeat",
      maskSize: "auto",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offsetAnchor: "auto",
      offsetDistance: 0,
      offsetPath: "none",
      offsetPosition: "normal",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "50% 50%",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionArea: "none",
      positionTryFallbacks: "none",
      positionTryOrder: "normal",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      right: "auto",
      rotate: "none",
      rowGap: "normal",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      scrollTimelineAxis: "block",
      scrollTimelineName: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(132, 245, 153)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textEmphasisColor: "rgb(33, 37, 41)",
      textEmphasisPosition: "over",
      textEmphasisStyle: "none",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      textWrapMode: "wrap",
      textWrapStyle: "auto",
      timelineScope: "none",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionBehavior: "normal",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimelineAxis: "block",
      viewTimelineInset: "auto",
      viewTimelineName: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      whiteSpaceCollapse: "collapse",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      accentColor: "auto",
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      anchorScope: "none",
      animationComposition: "replace",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationRangeEnd: "normal",
      animationRangeStart: "normal",
      animationTimeline: "auto",
      animationTimingFunction: "ease",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxDecorationBreak: "slice",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      containIntrinsicBlockSize: "none",
      containIntrinsicHeight: "none",
      containIntrinsicInlineSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicWidth: "none",
      containerName: "none",
      containerType: "normal",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "path(&quot",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "url(&quot",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "&quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: 16,
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesisSmallCaps: "auto",
      fontSynthesisStyle: "auto",
      fontSynthesisWeight: "auto",
      fontVariant: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantEmoji: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      interpolateSize: "numeric-only",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskClip: "border-box",
      maskComposite: "add",
      maskImage: "none",
      maskMode: "match-source",
      maskOrigin: "border-box",
      maskPosition: "0% 0%",
      maskRepeat: "repeat",
      maskSize: "auto",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offsetAnchor: "auto",
      offsetDistance: 0,
      offsetPath: "none",
      offsetPosition: "normal",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionArea: "none",
      positionTryFallbacks: "none",
      positionTryOrder: "normal",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      right: "auto",
      rotate: "none",
      rowGap: "normal",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      scrollTimelineAxis: "block",
      scrollTimelineName: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textEmphasisColor: "rgb(33, 37, 41)",
      textEmphasisPosition: "over",
      textEmphasisStyle: "none",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      textWrapMode: "wrap",
      textWrapStyle: "auto",
      timelineScope: "none",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionBehavior: "normal",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimelineAxis: "block",
      viewTimelineInset: "auto",
      viewTimelineName: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      whiteSpaceCollapse: "collapse",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    },
    d: "M172.1,221.2c0,0,2.9-40.6,26.6-65.4c6.6-6.8,15-11.5,24.2-13.6c7.1-1.6,18.7-7.3,28.8-26.3       c0,0,19.1-27,38.2-35.2s0-9.2,0-9.2s-54.6,10.4-89.6,42.4c-2.2,2-4.5,3.9-7,5.5c-9.1,6.2-34.2,29.6-33.1,97.9L172.1,221.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "flower-pot",
    gradientUnits: "userSpaceOnUse",
    x1: 965.7581,
    y1: -307.9589,
    x2: 1077.7224,
    y2: -307.9589,
    gradientTransform: "matrix(1 0 0 -1 -858.14 -49.79)",
    style: {
      accentColor: "auto",
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      anchorScope: "none",
      animationComposition: "replace",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationRangeEnd: "normal",
      animationRangeStart: "normal",
      animationTimeline: "auto",
      animationTimingFunction: "ease",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxDecorationBreak: "slice",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      containIntrinsicBlockSize: "none",
      containIntrinsicHeight: "none",
      containIntrinsicInlineSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicWidth: "none",
      containerName: "none",
      containerType: "normal",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "&quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: 16,
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesisSmallCaps: "auto",
      fontSynthesisStyle: "auto",
      fontSynthesisWeight: "auto",
      fontVariant: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantEmoji: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      interpolateSize: "numeric-only",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskClip: "border-box",
      maskComposite: "add",
      maskImage: "none",
      maskMode: "match-source",
      maskOrigin: "border-box",
      maskPosition: "0% 0%",
      maskRepeat: "repeat",
      maskSize: "auto",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offsetAnchor: "auto",
      offsetDistance: 0,
      offsetPath: "none",
      offsetPosition: "normal",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionArea: "none",
      positionTryFallbacks: "none",
      positionTryOrder: "normal",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      right: "auto",
      rotate: "none",
      rowGap: "normal",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      scrollTimelineAxis: "block",
      scrollTimelineName: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textEmphasisColor: "rgb(33, 37, 41)",
      textEmphasisPosition: "over",
      textEmphasisStyle: "none",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      textWrapMode: "wrap",
      textWrapStyle: "auto",
      timelineScope: "none",
      top: "auto",
      touchAction: "auto",
      transform: "matrix(1, 0, 0, -1, -858.14, -49.79)",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionBehavior: "normal",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimelineAxis: "block",
      viewTimelineInset: "auto",
      viewTimelineName: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      whiteSpaceCollapse: "collapse",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    className: "stop1",
    style: {
      accentColor: "auto",
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      anchorScope: "none",
      animationComposition: "replace",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationRangeEnd: "normal",
      animationRangeStart: "normal",
      animationTimeline: "auto",
      animationTimingFunction: "ease",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxDecorationBreak: "slice",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      containIntrinsicBlockSize: "none",
      containIntrinsicHeight: "none",
      containIntrinsicInlineSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicWidth: "none",
      containerName: "none",
      containerType: "normal",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "&quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: 16,
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesisSmallCaps: "auto",
      fontSynthesisStyle: "auto",
      fontSynthesisWeight: "auto",
      fontVariant: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantEmoji: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      interpolateSize: "numeric-only",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskClip: "border-box",
      maskComposite: "add",
      maskImage: "none",
      maskMode: "match-source",
      maskOrigin: "border-box",
      maskPosition: "0% 0%",
      maskRepeat: "repeat",
      maskSize: "auto",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offsetAnchor: "auto",
      offsetDistance: 0,
      offsetPath: "none",
      offsetPosition: "normal",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "50% 50%",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionArea: "none",
      positionTryFallbacks: "none",
      positionTryOrder: "normal",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      right: "auto",
      rotate: "none",
      rowGap: "normal",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      scrollTimelineAxis: "block",
      scrollTimelineName: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(229, 164, 237)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textEmphasisColor: "rgb(33, 37, 41)",
      textEmphasisPosition: "over",
      textEmphasisStyle: "none",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      textWrapMode: "wrap",
      textWrapStyle: "auto",
      timelineScope: "none",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionBehavior: "normal",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimelineAxis: "block",
      viewTimelineInset: "auto",
      viewTimelineName: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      whiteSpaceCollapse: "collapse",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    className: "stop2",
    style: {
      accentColor: "auto",
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      anchorScope: "none",
      animationComposition: "replace",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationRangeEnd: "normal",
      animationRangeStart: "normal",
      animationTimeline: "auto",
      animationTimingFunction: "ease",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxDecorationBreak: "slice",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      containIntrinsicBlockSize: "none",
      containIntrinsicHeight: "none",
      containIntrinsicInlineSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicWidth: "none",
      containerName: "none",
      containerType: "normal",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "&quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: 16,
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesisSmallCaps: "auto",
      fontSynthesisStyle: "auto",
      fontSynthesisWeight: "auto",
      fontVariant: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantEmoji: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      interpolateSize: "numeric-only",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskClip: "border-box",
      maskComposite: "add",
      maskImage: "none",
      maskMode: "match-source",
      maskOrigin: "border-box",
      maskPosition: "0% 0%",
      maskRepeat: "repeat",
      maskSize: "auto",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offsetAnchor: "auto",
      offsetDistance: 0,
      offsetPath: "none",
      offsetPosition: "normal",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "50% 50%",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionArea: "none",
      positionTryFallbacks: "none",
      positionTryOrder: "normal",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      right: "auto",
      rotate: "none",
      rowGap: "normal",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      scrollTimelineAxis: "block",
      scrollTimelineName: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(122, 91, 245)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textEmphasisColor: "rgb(33, 37, 41)",
      textEmphasisPosition: "over",
      textEmphasisStyle: "none",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      textWrapMode: "wrap",
      textWrapStyle: "auto",
      timelineScope: "none",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionBehavior: "normal",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimelineAxis: "block",
      viewTimelineInset: "auto",
      viewTimelineName: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      whiteSpaceCollapse: "collapse",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      accentColor: "auto",
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      anchorScope: "none",
      animationComposition: "replace",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationRangeEnd: "normal",
      animationRangeStart: "normal",
      animationTimeline: "auto",
      animationTimingFunction: "ease",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxDecorationBreak: "slice",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      containIntrinsicBlockSize: "none",
      containIntrinsicHeight: "none",
      containIntrinsicInlineSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicWidth: "none",
      containerName: "none",
      containerType: "normal",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "path(&quot",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "url(&quot",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "&quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: 16,
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesisSmallCaps: "auto",
      fontSynthesisStyle: "auto",
      fontSynthesisWeight: "auto",
      fontVariant: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantEmoji: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      interpolateSize: "numeric-only",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskClip: "border-box",
      maskComposite: "add",
      maskImage: "none",
      maskMode: "match-source",
      maskOrigin: "border-box",
      maskPosition: "0% 0%",
      maskRepeat: "repeat",
      maskSize: "auto",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offsetAnchor: "auto",
      offsetDistance: 0,
      offsetPath: "none",
      offsetPosition: "normal",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionArea: "none",
      positionTryFallbacks: "none",
      positionTryOrder: "normal",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      right: "auto",
      rotate: "none",
      rowGap: "normal",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      scrollTimelineAxis: "block",
      scrollTimelineName: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textEmphasisColor: "rgb(33, 37, 41)",
      textEmphasisPosition: "over",
      textEmphasisStyle: "none",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      textWrapMode: "wrap",
      textWrapStyle: "auto",
      timelineScope: "none",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionBehavior: "normal",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimelineAxis: "block",
      viewTimelineInset: "auto",
      viewTimelineName: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      whiteSpaceCollapse: "collapse",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    },
    d: "M219.5,217.9c0,0,0.8-4.9-5.7-4.8c-5.7,0.2-102.1-0.5-102.1-0.5s-4.5,0-4.2,3.4s14.9,83.7,16.3,85.4       c0.6,1,1.6,1.8,2.8,2.1c1.8,0.5,69.5,0.1,69.5,0.1c1.6-0.2,2.8-1.5,2.9-3.1C198.9,300.6,219.7,218.9,219.5,217.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTulip);
export default __webpack_public_path__ + "static/media/Tulip.e1d5df8a7a908744c890eebbe9e8d4be.svg";
export { ForwardRef as ReactComponent };